var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{attrs:{"action":"","http-request":_vm.upload,"on-change":_vm.uploadChanged,"before-upload":_vm.beforeUpload,"multiple":false,"auto-upload":true,"show-file-list":false,"accept":_vm.accept}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }